var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseLook = function SvgCloseLook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.85 6C9.582 6 7.5 7.027 5.845 8.26c-1.658 1.236-2.94 2.717-3.623 3.719L2 12.304l.242.31c.734.938 2.092 2.325 3.81 3.48 1.715 1.154 3.84 2.111 6.097 2.111 2.26 0 4.337-.959 5.993-2.116 1.659-1.159 2.942-2.548 3.627-3.49L22 12.28l-.232-.317c-.733-.999-2.088-2.476-3.807-3.71C16.247 7.026 14.118 6 11.851 6m-5.197 9.2a16.8 16.8 0 0 1-3.31-2.94 15.9 15.9 0 0 1 3.145-3.136c1.557-1.16 3.415-2.047 5.363-2.047 1.95 0 3.86.89 5.482 2.053a17.2 17.2 0 0 1 3.324 3.153 15.4 15.4 0 0 1-3.132 2.923c-1.555 1.087-3.418 1.922-5.376 1.922-1.96 0-3.875-.837-5.496-1.927m7.381-3.205a2.034 2.034 0 1 1-4.068 0 2.034 2.034 0 0 1 4.068 0m1.077 0a3.111 3.111 0 1 1-6.222 0 3.111 3.111 0 0 1 6.222 0",
    clipRule: "evenodd"
  })));
};
export default SvgCloseLook;